/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';
import { useSessionContext } from '@exo/frontend-common-session-context';

export const useMarketingSpot = (eSpotName, skipCondition = false) => {
  const session= useSessionContext()
  const variables = {
      eSpotName: eSpotName
    };

  const ESPOT_GQL = gql`
    query ($eSpotName: String) {
      eMarketingSpotByName(eSpotName: $eSpotName) {
        resourceId
        resourceName
        baseUrl
        MarketingSpotData {
          nextTimeLimit
          marketingSpotIdentifier
          behavior
          eSpotName
          baseMarketingSpotActivityData {
            standardPriceCurrency
            standardPrice
            productId
            listPriceCurrency
            ownerID
            productPartNumber
            catalogEntryTypeCode
            listPrice
            contentFormatName
            baseMarketingSpotActivityName
            contentClickAction
            contentId
            baseMarketingSpotActivityID
            contentName
            baseMarketingSpotDataType
            activityIdentifierID
            contentFormatId
            activityPriority
            contentStoreId
            description {
              longDescription
              thumbnail
              language
              shortDescription
              fullImage
              productName
            }
            marketingContentDescription {
              marketingText
              language
            }
          }
          defaultContentDisplaySequence {
            resultId
            resultFormat
            displaySequence
          }
        }
      }
    }
  `;

  const { loading, error, data, refetch } = useQuery(
  ESPOT_GQL,
  { variables, fetchPolicy:'cache-first', skip: skipCondition, context: {
        headers: {
          Authorization: 'Bearer ' + session.token
        },
        clientName: "espot"
      } }
  );

  handleApolloError(__filename, error);

  return { error, loading, data: (data) ?? [], refetch };
};
